import React from 'react'
import TopNavigation from '../Components/navigation/TopNavigation'
import bannerHero from './../assets/cancelpayf.png';
import MainFooter from '../Components/footer/MainFooter';
import { Helmet } from 'react-helmet';

function PaymentCancel() {
  return (
    <div className="main-layer">
        <Helmet>
           <title>Lovedripp - Payment Cancelled </title>
        </Helmet>
            <TopNavigation title={"Payment Cancelled"} classBack="full-white"/>
            <div className="content-layer">
                 <div className="banner-photo-show middle-align txt-white short-banner" 
                      style={{backgroundImage: `url("${bannerHero}")`}}>     
                      <div className="info-hero-intro">
                          <h1>Payment Was UNSUCCESSFUL</h1>                    
                      </div>                 
                  </div>
                  <div className="section-item">  

                  </div>
            </div>
            <MainFooter />
    </div>
  )
}

export default PaymentCancel